<template>
  <div id="page-history-detail" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="page-history-detail py-3">
        <div class="content-loader" v-if="loadingH">
          <!--div id="loader"></div-->
          <div id="loader2"></div>
          <div class="cssload-dots">
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
          </div>
          <!--div id="loader2"></div-->
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div style="display: flex">
                <label class="mr-2 breadcrumb-link"><a href="../../">Historial de reportes</a></label>
                <label class="breadcrumb-nolink">
                  > Detalle de tu reporte</label>
              </div>
            </div>
          </div>
          <!--img class="img-fluid" alt="Responsive image" src="@/assets/images/tipshift/desktop.png" /-->
          <div class="row">
            <div class="col-md-12">
              <div style="display: flex">
                <div>
                  <div class="ml-0" style="position: realtive; top: -1px">
                    <h2>Detalle de tu reporte</h2>

                    <h3>Bodega</h3>
                  </div>
                </div>

                <div class="reloj-letras pl-2 mt-2" style="display: flex; flex-direction: row">
                  <div>
                    <!--span class="icon icon-clock" ></span-->
                    <img alt="Calendar" src="@/assets/images/icons/calendar.svg" />
                  </div>
                  <br />
                  <div class="ml-3" style="position: realtive; top: -1px">
                    <span class="tbl_header" style="font-weight: bold;color:#color: #546E7A;">Fecha de
                      reporte</span><br />
                    <span class="label-regular" style="color: #546e7a">
                      {{ this.$moment(this.fecha).format("LL") }}</span>
                  </div>
                </div>

                <div class="box-pendiente pl-2 mt-2" style="display: flex; flex-direction: row" v-if="
                  this.turno == null
                    ? false
                    : this.turno.status == 1
                      ? true
                      : false
                ">
                  <div class="ml-3" style="position: realtive; top: -1px">
                    <span class="tbl_header" style="font-weight: bold;color:#color: #546E7A;">Estado de la
                      novedad</span><br />
                    <img class="leftImg1" src="@/assets/images/icons/pendiente.svg" />
                  </div>
                </div>

                <div class="box-cerrado pl-2 mt-2" style="display: flex; flex-direction: row" v-if="
                  this.turno == null
                    ? false
                    : this.turno.status == 2
                      ? true
                      : false
                ">
                  <div class="ml-3" style="position: realtive; top: -1px">
                    <span class="tbl_header" style="font-weight: bold;color:#color: #546E7A;">Estado de la
                      novedad</span><br />
                    <img class="leftImg1" src="@/assets/images/icons/cerrado.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <div class="alert alert-dark alert-sm alert-info-custom" role="alert"
                v-if="this.msgDiasHabiles && this.getColaboradores.length > 0">
                <h5>
                  <span class="icon icon-info text-primary mr-2"></span>
                  {{
                      this.msgDiasHabiles > 0
                        ? "Recuerda que tienes máximo " +
                        this.msgDiasHabiles +
                        " días hábiles para realizar la modificación de tu reporte."
                        : "El tiempo para la modificación de tu reporte ha finalizado."
                  }}
                </h5>
              </div>

              <div class="alert alert-dark alert-sm alert-info-custom" role="alert"
                v-if="this.getColaboradores.length == 0">
                <h5>
                  <span class="icon icon-info text-primary mr-2"></span>
                  No se ha realizado ningún reporte de turnos para este día.
                </h5>
              </div>
              <div class="card mb-4 card-personalizada" v-if="this.getColaboradores.length > 0">
                <div class="card-header text-left card-header-left">
                  <h3>Reporte de turnos</h3>
                </div>
                <div class="card-body">
                  <div class="ml-4 mt-2 mb-1 mr-1">
                    <datatable :columns="datatable.columns" :data="getColaboradores"
                      class="table table-hover table-borderless rounded-circle">
                    </datatable>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="col-12 mb-4" style="padding-left: 0px">
                <ProfitsMonth />
              </div>
              <div class="col-12 mb-4" style="padding-left: 0px">
                <button pill v-on:click="ver_historial" class="text-center small-flat mt-2" variant="light"
                  style="border: none; width: 100%">
                  Ver historial de modificaciones<span class="icon icon-eye1 ml-2 mt-1"></span>
                </button>
              </div>
            </div>
          </div>

          <div class="row" v-if="this.getNovedades.length > 0 || this.getRotativos.length > 0">
            <div class="col-md-12">
              <h3>Novedades reportadas:</h3>

              <div class="content-toggle">
                <div class="toggle-search">
                  <button type="button" name="btn_Reemplazos" class="btn_optionlogin" @click="ActiveBtnReemplazos"
                    :class="{ bn_active: activeBtn === 'Reemplazos' }">
                    <span class="cta ml-3"> Reemplazos</span>
                    <div class="Novedades" v-if="getTotalNovedades > 0">
                      {{ getTotalNovedades }}
                    </div>
                  </button>

                  <button type="button" name="btnRotativos" class="btn_optionlogin" @click="ActiveBtnRotativos"
                    :class="{ bn_active: activeBtn === 'Rotativos' }">
                    <span class="cta"> Rotativos</span>
                    <div class="Novedades" v-if="getTotalRotativos > 0">
                      {{ getTotalRotativos }}
                    </div>
                  </button>
                </div>
              </div>
              <b-card-text v-if="activeBtn == 'Reemplazos'">
                <div class="card card-personalizada">
                  <div class="card-header text-left card-header-novedad">
                    <b>Persona que realiza el reemplazo</b>
                  </div>
                  <div class="card-body ml-3">
                    <!--div class="table-responsive"-->
                    <datatable :columns="datatableNovedad.columns" :data="getNovedades"
                      class="table table-hover table-borderless">
                    </datatable>
                    <!--/div-->
                  </div>
                  <div class="card-body" style="width: 100%">
                    <div class="text-left ml-4 text-novedad-descripcion">
                      <b>¿Tienes algo por contar acerca de esta novedad?</b>
                    </div>
                    <div class="baseline_box ml-4 mr-4" id="baseline_box1">
                      <textarea id="textarea" v-model="descripcion" class="ml-4" width="900px"
                        placeholder="Descripción de la novedad"></textarea>
                      <label for="textarea">Descripción de la novedad
                      </label>
                    </div>
                  </div>
                </div>
              </b-card-text>
              <b-card-text v-if="activeBtn == 'Rotativos'">
                <div class="card card-personalizada">
                  <div class="card-header text-left card-header-novedad">
                    <b>Persona que realiza el reemplazo</b>
                  </div>
                  <div class="card-body ml-3" style="width: 100%">
                    <!--div class="table-responsive"-->
                    <datatable :columns="datatableNovedad.columns" :data="getRotativos"
                      class="table table-hover table-borderless">
                    </datatable>
                    <!--/div-->
                  </div>
                  <div class="card-body">
                    <div class="text-left ml-4 text-novedad-descripcion">
                      <b>¿Tienes algo por contar acerca de esta novedad?</b>
                    </div>
                    <div class="baseline_box ml-4 mr-4" id="baseline_box1">
                      <textarea id="textarea" v-model="descripcion" class="ml-4" width="900px"
                        placeholder="Descripción de la novedad"></textarea>
                      <label for="textarea">Descripción de la novedad
                      </label>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </div>
          </div>
          <div class="col-md-12 mt-3 text-center">
            <button class="button-primary enviar-mensaje" style="border: none" v-on:click="editar_reporte" size="lg"
              v-if="
                user.core_role_code != 'jefe-zona' &&
                user.core_role_code != 'nomina'
              ">
              <span class="cta" style="width: 80%"> Editar reporte </span>
              <span class="icon icon-checkmark" style="margin-left: 16px; width: 10%"></span>
            </button>
          </div>
          <!-- .row -->
        </div>
        <!-- .layout-content -->
      </div>
    </div>
    <b-modal id="modal-historial" size="xl" centered>
      <template>
        <div class="col-12 d-flex flex-column align-items-center mb-4">
          <!--h1 class="display-1"><span v-bind:class="modal_class"></span></h1-->
          <span v-bind:class="modal_class" class="display-1"></span>
        </div>
        <div class="col-12 d-flex flex-column align-items-center mt-4 mb-4">
          <h3 v-if="historial.length > 0">
            <b>Historial del modificaciones realizadas</b>
          </h3>
          <h3 v-if="historial.length == 0"><b>No tiene historial</b></h3>
        </div>
        <div class="col-12">
          <datatable :columns="datatableHistorial.columns" :data="this.historial"
            class="table table-hover table-borderless" v-if="historial.length > 0">
          </datatable>
        </div>
      </template>

      <template #modal-footer="{ ok }" class="w-100">
        <div class="col-12 d-flex flex-column align-items-center mt-0 w-100">
          <button class="button-primary" size="lg" @click="ok()">
            <span clas="cta-small">Volver</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
  <!-- #page-history-detail -->
</template>

<script>
//import TemplateLetter from "./TemplateLetter.vue";
import EstadoNovedadesShow from "@/components/datatables/EstadoNovedadesShow.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import ProfitsMonth from "@/components/profits/ProfitsMonth.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import serverConfig from "../../services/config";

export default {
  name: "tipsreporthistory",
  components: {
    MainBarMenuV2,
    ProfitsMonth,
    HeadingUser,
  },
  data() {
    return {
      activeBtn: "Reemplazos",
      id: this.$route.params.id,
      fecha: this.$route.params.fecha,
      pdv: this.$route.params.pdv,
      msgDiasHabiles: null,
      // Modal
      modal_title: "",
      modal_msg: "",
      modal_class: "icon icon-success text-success",

      descripcion: "",
      selected: [], // Must be an array reference!
      checked: false,
      text: "",
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "datatable", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      // Datatable puntos de ventas
      datatable: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "Nombre y apellidos",
            field: "core_employee.name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Cargo",
            field: "core_employee.position.name",
            align: "center",
            headerClass: "text-center",
          },
          {
            label: "Puntaje",
            field: "point",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              let val =
                row.point == undefined ? 0 : row.point == null ? 0 : row.point;
              val = (val / 1).toFixed(2).replace(".", ",");
              val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return val;
            },
          },
          {
            label: "Propina",
            field: "close_value",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              let val =
                row.close_value == undefined
                  ? 0
                  : row.close_value == null
                    ? 0
                    : row.close_value;
              val = (val / 1).toFixed(2).replace(".", ",");
              val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return " $ " + val;
            },
          },
        ],
        rows: [],
      },

      // Datatable historial
      datatableHistorial: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "Manager",
            align: "left",
            field: "manager",
            sortable: false,
          },
          {
            label: "Tipo de modificación",
            field: "accion",
            align: "left",
            representedAs: function (row) {
              return row.accion + " - " + row.colaborador;
            },
          },
          {
            label: "Origen",
            field: "origen",
            align: "left",
          },
          {
            label: "Fecha y hora",
            field: "fecha",
            align: "right",
          },
        ],
        rows: [],
      },

      // Datatable novedades
      datatableNovedad: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "Nombres y apellidos",
            field: "core_employee.name",
            align: "right",
            headerClass: "text-right",
          },
          {
            label: "Cédula",
            field: "core_employee.cc",
            align: "right",
            headerClass: "text-right",
          },
          {
            label: "Cargo Reemplazo",
            field: "position.name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Puntaje",
            field: "points",
            align: "left",
            headerClass: "text-left"
          },
          {
            label: "Punto de venta",
            field: "pro_point_sale.name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Propina",
            field: "close_value",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              let val =
                row.close_value == undefined
                  ? 0
                  : row.close_value == null
                    ? 0
                    : row.close_value;
              val = (val / 1).toFixed(2).replace(".", ",");
              val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return " $ " + val;
            },
          },
          {
            label: "Estado",
            field: "status",
            align: "right",
            headerClass: "text-right",
            component: EstadoNovedadesShow,
          },
        ],
        rows: [],
      },
    };
  },
  beforeMount() {
    // Obtener data
    let data = {
      id: this.id,
      fecha: this.fecha,
    };
    this.actGetColaboradoresNovedades(data)
      .then((res) => {
        if (res.data.novedades.length > 0) {
          this.descripcion = res.data.novedades[0].description;
        }
        this.msgDiasHabiles = res.data.diasHabiles;
      })
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message =
          "No se pudo conectar al servicio: error: " + response;
      });

    // obtener el historial
    this.actGetHistorial(this.id) /*.then((res) =>{
      console.log(res);
    })*/
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message =
          "No se pudo conectar al servicio: error: " + response;
      });

    // setear config component
    let configTips = {
      id: this.pdv,
      name: "Linea de negocio ",
      title: "Ganancias del día",
      general: " ", // o fecha,
      nameTitle: "",
    };
    this.actSetComponentePropinas(configTips);

    // Obtener propinas por dia
    let dataPro = {
      data: {
        pro_point_sale_id: this.pdv,
        date: this.fecha,
      },
      func: "getTipsDaily",
    };
    this.actGetPropinasGeneral(dataPro)
      .then(() => {
        // Dibujar contenido
      })
      .catch((response) => {
        if (
          this.demands.data.error != undefined &&
          this.demands.data.error.trace.function == "unauthenticated"
        ) {
          this.setUser("");
          localStorage.setItem("token", "");
          this.showModal(
            "Su sesión ha terminado o ha iniciado sesión en otro dispositivo, por favor vuelva a ingresar",
            1
          );
        } else {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;
        }
      });
  },
  beforeDestroy() {
    this.actSetTableNovedades([]);
  },
  computed: {
    ...mapState("modCore", ["user", "userData"]),

    ...mapState("modTipshiftReportHistory", [
      "turnos",
      "loadingH",
      "colaboradores",
      "novedades",
      "historial",
      "turno",
    ]),

    ...mapGetters("modTipshiftReportHistory", [
      "getNovedades",
      "getRotativos",
      "getTotalNovedades",
      "getColaboradores",
      "getTotalRotativos",
    ]),

    ...mapState("modReportTips", ["propinasGeneral", "loading"]),

    ...mapState("modTipshiftReport", ["tipshift"]),
  },

  methods: {
    ...mapActions("modTipshiftReportHistory", [
      "actGetColaboradoresNovedades",
      "actGetHistorial",
      "actSetTableNovedades",
    ]),

    ...mapActions("modTipshiftReport", ["actSelectRow"]),

    ...mapActions("modReportTips", [
      "actGetPropinasGeneral",
      "actSetComponentePropinas",
    ]),

    ActiveBtnReemplazos() {
      this.activeBtn = "Reemplazos";
    },

    ActiveBtnRotativos() {
      this.activeBtn = "Rotativos";
    },

    editar_reporte() {
      this.$router.push({
        path: "/tipshiftReport/" + this.id + "/" + this.fecha + "/" + this.pdv,
      });
    },

    ver_historial() {
      this.$bvModal.show("modal-historial");
    },

    seleccionarRow(row, selected) {
      row.selected = selected;
      this.actSelectRow(row)
        .then(() => { })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo seleccionar todos los registros: " + response;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/*@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');*/
.page-history-detail {
  .table tbody tr td {
    font-size: 14px;
    color: #454545;
  }

  .title-3 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }

  .cont-request-text {
    .cont-title {
      color: #1c3a4e;

      .title-1 {
        font-size: 40px;
        font-weight: bold;
      }

      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }

    .form-request {
      .button1 {
        font-family: "Open Sans";
        background: #e9ecee;
        color: #1c3a4e;
        font-weight: bold;
        //border-radius: 50px;
        height: 32px;
        font-size: 14px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        outline: none;
        border: none;

        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }

      .button2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 100px;
        height: 42px;
        width: 220px;
        font-size: 14px;
        text-align: center !important;
        padding-left: 2%;
        padding-right: 2%;

        &:hover {
          background: darken(#7a7c7e, 5);
        }

        .button3 {
          border-radius: 50px;
          font-family: "Open Sans";
          color: #1c3a4e;
          font-size: 20px;
          border: 0 none;
          outline: none;
          text-decoration: none;
          border: 2px solid #1c3a4e;
          /*&:hover {
              text-decoration: none;
              color: #ffffff;
              background: darken(#1c3a4e, 5);
          }*/
        }
      }
    }
  }

  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #979494;
    text-align: center !important;
  }

  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #999797;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .button4 {
    background: #99a6af;
    color: #ffffff;
    border-radius: 8px;
    height: 20px;
    font-size: 8px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;

    &:hover {
      background: darken(#99a6af, 5);
    }
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  .centerImg2 {
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    padding-right: 2%;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    //position: absolute;
    //left: 50%;
    top: 100%;
    //margin-left: -8px;
    //margin-top: 8px;
    float: right;
    //clear: right;
  }

  .mycheck {
    /*vertical-align: middle;
    position: relative;
    bottom: 1px;
    border-radius: 20%;*/
    width: 1.3em;
    height: 1.3em;

    border-radius: 30%;
    vertical-align: middle;
    border: 1px solid #ddd;
    //-webkit-appearance: none;
    //outline: none;
    //cursor: pointer;
  }

  .mycheck:checked {
    background-color: #1c3a4e;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked+.slider {
    background-color: #779b49;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #779b49;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .style-filter .vs__search::placeholder,
  .style-filter .vs__dropdown-toggle,
  .style-filter .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
    font-size: 11px;
    line-height: 12px;
  }

  .style-filter .vs__clear,
  .style-filter .vs__open-indicator {
    fill: #394066;
  }

  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }

  .nav-item {
    text-decoration-color: #1c6776 !important;
    border-left-color: #1c6776 !important;
    border-left-width: thick !important;
    background-color: rgba(0, 0, 0, 0.03) !important;
  }

  .card-header {
    background-color: none !important;
  }

  .chips {
    /* Auto Layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    width: 61px;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    /* Alert / Error Bg */
    background: #feefef;
    border-radius: 4px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .iconClose {
    /* Alert/Error */
    color: #da1414;
  }

  .iconPendiente {
    /* Alert/Error */
    color: #e06100;
  }

  .iconProceso {
    /* Alert/Error */
    color: #2e5aac;
  }

  .textClose {
    position: static;
    height: 16px;
    left: 22px;
    right: 4px;
    top: calc(50% - 16px / 2);
    /* Placeholder */
    font-family: Open Sans;
    font-style: italic;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    /* Alert/Error */
    color: #da1414;
  }

  .card-header {
    width: 100%;
    //@errorbackground: #EDF9F0;
    border-bottom: none;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    background: #ececff !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  /* .card-header-left{
   
    background: #F5F5F5;
 
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;
  }*/

  .card-personalizada {
    /*flex-direction: column;
    background: #FFFFFF;
   border: 1px solid #DDDDDD;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgb(110 116 134 / 12%);
    border-radius: 8px;*/

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .card-left {
    /* Auto Layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 16px;
    /* Neutral / White */
    background: #ffffff;
    /* Neutral / Gray 3 */
    border: 1px solid #dddddd;
    box-sizing: border-box;
    /* up extra */
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
  }

  .card-text-name {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 1 */
    color: #454545;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 4px;

    /* Elipsis nombre */
    width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .card-body {
    padding-top: 10px;
    padding-left: 0px;
    padding-bottom: 10px;
  }

  .card-text-cargo {
    /* Body Tablas - Párrafo mediano */

    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: right;

    /* Neutral / Gray 1 */

    color: #454545;

    /* Inside Auto Layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 4px;

    // Elipsis cargo
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }


  .card-left-titulo {
    /* Header Tablas */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    /* Primary / 1 */
    color: #1c3a4e;
  }

  table {
    //border-collapse: collapse;
    border-radius: 8px !important;
  }

  thead>tr {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    /* Alert / Info Bg */
    background: #eef2fa;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin: 0px 0px;

    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Black */
    color: #000000;
  }

  tbody>tr {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Gray 1 */
    color: #454545;
  }

  table>input {
    border: 1px solid #aaaaaa;
    box-sizing: border-box;
    border-radius: 2px;
    background: #269887;
  }

  .selection-table {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    border-radius: 8px;
  }

  .custom-control-input:checked~.custom-control-label::before {
    color: #fff;
    border-color: #269887;
    background-color: #269887;
  }

  .checkbox-blue:checked~.checkbox-blue::before {
    color: #fff;
    border-color: #269887;
    background-color: #269887;
  }

  .btn {
    background: #269887;
    border: transparent;
  }

  .btn:hover {
    background: #1c6776;
    border: transparent;
  }

  .text-novedad-info {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;
    /* Primary / 3 */
    color: #269887;
  }

  // Tabla de reemplazos, rotativos, editar puntaje
  .tabs-novedades {
    .col-auto {
      background-color: transparent;
    }

    ul {
      background-color: transparent;
    }

    .nav-item {
      background-color: transparent;
      border-bottom: 1px solid #e9ecee;
      width: 180px;

      a {
        color: black;
      }
    }

    .nav-pills {
      margin-left: 0px;
      padding-left: 0px;
      margin-top: 10px;
    }

    .nav-link {
      height: 80px;
      margin-left: 0px;
      padding-left: 0px;
      background-color: transparent;
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
    }

    .nav-pills .nav-link.active,
    .nav-pills .show>.nav-link {
      color: black;
      background-color: white;
      /* Neutral / Black */
      color: #000000;
    }

    .page-tips-shift .tabs .nav-link {
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
      /* Neutral / Black */
      color: #000000;
      background-color: white;
    }

    .tab-title-content {
      height: 60px;
      padding-left: 5px;
      //border-left: 4px solid transparent;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .nav-link.active>.tab-title-content {
      border-left: 4px solid #269887;
    }

    .tab-title-muted-ul {
      margin: 0px;
      padding: 0px;
    }

    .tab-title-muted {
      /* Body Semibold */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      /* Primary / 3 */
      color: #269887;
    }

    .tab-title-r {
      color: #269887;
      //margin-top: 15px;
      vertical-align: middle;
    }

    .tab-title-r-10 {
      color: #269887;
      margin-top: 3px;
    }

    /*  .card-header-novedad{
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #2f3d46;
      background: #F5F5F5;
    }*/

    /* .text-novedad-descripcion{
      
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      
      color: #454545;
    }*/
    .text-novedad-descripcion {
      /* Header Tablas */
      /* body regular */

      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      /* identical to box height, or 175% */

      /* content/09 */

      color: #263238;

      /* Inside auto layout */

      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      margin: 4px 0px;
    }

    .text-novedad-buscar {
      /* Body Tablas - Párrafo mediano */
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      /* identical to box height */
      display: flex;
      align-items: center;
      justify-content: center;
      /* Neutral / Gray 1 */
      color: #454545;
    }
  }

  .text-buscar {
    background: #ffffff;
    /* Neutral / Gray 3 */
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 8px;

    .input-group-prepend {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon-search1 {
      color: #dadada;
    }

    .icon-search1::before {
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: center;
    }

    input {
      height: 40px;
      border: 0px;
      margin-left: -10px;
    }

    ::placeholder {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #aaaaaa;
    }
  }

  .label-textarea {
    margin-top: 0px;
  }

  .label-textarea label {
    width: 150px;
    position: relative;
    top: 20px;
    left: 30px;
    margin-top: 0px;
    border-radius: 1px;
    background: white;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 2 */
    color: #aaaaaa;
    text-align: left;
  }

  .textarea-novedad {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #454545;

    background: #ffffff;
    border: 1px solid #aaaaaa;
    box-sizing: border-box;
    border-radius: 8px;
    width: 98%;
    height: 92px;
    margin-top: 10px;
    padding-top: 10px;
    scroll-behavior: auto;

    ::placeholder {
      margin-top: 100px;
    }
  }

  .reloj-letras {
    padding: 0px;
    margin-left: 20px;
    position: relative !important;
    width: 184px;
    height: 52px;
    //left: calc(50% - 382px/2) !important;
    //top: calc(50% - 48px/2) !important;

    /* highlight/info/background */

    background: #e6f7ff;
    /* highlight/info/medium */

    border: 1px solid #0075ff;
    box-sizing: border-box;
    border-radius: 4px;
  }

  .info-alert {
    padding: 0px;
    //margin-left:20px;
    margin-top: 20px;
    width: auto;
    height: 64px;
    position: relative !important;
    background: #e6f7ff !important;
    border: 1px solid #0075ff;
    box-sizing: border-box;
    border-radius: 4px;

    span {
      width: 595px;
      height: 56px;

      /* body regular */

      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      /* or 175% */

      /* content/09 */

      color: #263238;
    }
  }

  .box-pendiente {
    padding: 0px;
    margin-left: 20px;
    position: relative !important;
    width: 184px;
    height: 52px;
    background: #fffbe6;
    /* highlight/alert/dark */
    border: 1px solid #e66401;
    border-radius: 4px;
  }

  .box-cerrado {
    padding: 0px;
    margin-left: 20px;
    position: relative !important;
    width: 184px;
    height: 52px;
    background: #f6ffed;
    /* highlight/alert/dark */
    border: 1px solid #00761a;
    border-radius: 4px;
  }

  .contenedor-quitar {
    width: 100%;
  }

  .alert-info-custom {
    /* Alert / Info Bg */
    background: #eef2fa;
    border-radius: 8px;
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */
    /* Neutral / Black */
    color: #000000;
  }

  .span-reloj {
    /* Alert / Info Bg */
    background: #eef2fa;
    border-radius: 20px;
  }

  .icon-lock {
    color: #779b49;
  }

  .icon-circle-clock {
    color: #e48d3d;
  }

  .span-icon-pendiente {
    /* Alert / Warning Bg */
    background: #fff4ec;
    border-radius: 20px;
  }

  .span-icon-cerrado {
    /* Alert / Warning Bg */
    background: #edf9f0;
    border-radius: 20px;
  }

  .text-ver-historial {
    /* Body Semibold */

    color: #5d5fef;
  }

  .text-ver-historial:hover {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* Primary / 3 */
    color: #269887;
  }
}

/* Center the loader */
#loader {
  position: relative;
  z-index: 1072;
  left: 50%;
  top: 50%;
  z-index: 1;

  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.content-loader {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1071;
  background-color: #fff;
  opacity: 0.9;
}

.modal-content {
  /* Neutral / White */
  background: #ffffff;
  /* up extra */
  box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
  border-radius: 16px !important;
}

.content-toggle {
  /* _tab variants / horizontal */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  border: none;
  box-sizing: border-box;

  position: static;
  width: 376px;
  height: 56px;
  left: 28px;
  top: 228px;

  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 30px 0px;

  .Novedades {
    /* Auto layout */

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px;

    position: static;
    width: 16px;
    height: 16px;
    left: 128px;
    top: 12px;

    /* highlight/info/medium */

    background: #0075ff;
    border-radius: 100px;
    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 11px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;

    /* Inside auto layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 8px;
  }

  .toggle-search {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px;

    position: static;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;

    /* CTA/00 */

    background: #ececff;
    /* CTA/01 */

    border: 1px solid #c9caff;
    box-sizing: border-box;
    border-radius: 48px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 0px;
  }
}
</style>
<style>
.modal-footer {
  width: inherit !important;
  border-top: 0 !important;
}
</style>